import { BFormRadioGroup } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBFormRadioGroup when migrating. */
export const EgBFormRadioGroup = createEgBootstrapProxy(
  "EgBFormRadioGroup",
  BFormRadioGroup
);
